import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createGuidelines, deleteGuidelines, getGuidelines, queryGuidelines, updateGuidelines } from '@wix/ambassador-asa-preferences-v1-guidelines/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { GuidelinesClientBase } from './GuidelinesClientBase';
export class GuidelinesClient extends HttpBaseClient(GuidelinesClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createGuidelinesImpl", createGuidelines);
    _defineProperty(this, "getGuidelinesImpl", getGuidelines);
    _defineProperty(this, "updateGuidelinesImpl", updateGuidelines);
    _defineProperty(this, "deleteGuidelinesImpl", deleteGuidelines);
    _defineProperty(this, "queryGuidelinesImpl", queryGuidelines);
  }
}
//# sourceMappingURL=GuidelinesClientHttp.js.map